let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("87kVp")).then(() => parcelRequire('3chUb'));